import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Send, Mail, MessageSquare, User } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [sent, setSent] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setForm({
        name: '',
        email: '',
        message: ''
      });
      onClose();
    }, 2500);
  };
  return <AnimatePresence data-id="element-1">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50" style={{
        backgroundColor: 'rgba(5,10,20,0.85)',
        backdropFilter: 'blur(6px)'
      }} data-id="element-2" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-3">
            <div className="relative w-full max-w-lg rounded-2xl p-8 pointer-events-auto" style={{
          backgroundColor: '#0C1628',
          border: '1px solid rgba(14,165,233,0.2)',
          boxShadow: '0 0 80px rgba(14,165,233,0.1)'
        }} data-id="element-4">
              <button onClick={onClose} className="absolute top-5 right-5 p-2 rounded-full transition-colors" style={{
            color: '#475569',
            backgroundColor: 'rgba(14,165,233,0.06)'
          }} data-id="element-5">
                <X size={18} data-id="element-6" />
              </button>

              <h2 className="text-2xl font-black mb-1" style={{
            color: '#F1F5F9'
          }} data-id="element-7">
                Contacto
              </h2>
              <p className="text-sm mb-8" style={{
            color: '#475569'
          }} data-id="element-8">
                ¿Tienes preguntas? Estamos aquí para ayudarte.
              </p>

              <AnimatePresence mode="wait" data-id="element-9">
                {sent ? <motion.div key="success" initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0
            }} className="text-center py-10" data-id="element-10">
                    <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
                backgroundColor: 'rgba(16,185,129,0.15)',
                border: '1px solid rgba(16,185,129,0.3)'
              }} data-id="element-11">
                      <Send size={24} style={{
                  color: '#10B981'
                }} data-id="element-12" />
                    </div>
                    <p className="text-lg font-bold mb-1" style={{
                color: '#F1F5F9'
              }} data-id="element-13">
                      ¡Mensaje enviado!
                    </p>
                    <p className="text-sm" style={{
                color: '#64748B'
              }} data-id="element-14">
                      Te responderemos en menos de 24 horas.
                    </p>
                  </motion.div> : <motion.form key="form" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} onSubmit={handleSubmit} className="space-y-5" data-id="element-15">
                    <div data-id="element-16">
                      <label className="block text-xs font-bold mb-2 uppercase tracking-wider" style={{
                  color: '#475569'
                }} data-id="element-17">
                        <User size={11} className="inline mr-1" data-id="element-18" />
                        Nombre
                      </label>
                      <input type="text" required value={form.name} onChange={e => setForm({
                  ...form,
                  name: e.target.value
                })} placeholder="Tu nombre completo" className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-all" style={{
                  backgroundColor: 'rgba(14,165,233,0.05)',
                  border: '1px solid rgba(14,165,233,0.15)',
                  color: '#F1F5F9'
                }} onFocus={e => e.target.style.borderColor = 'rgba(14,165,233,0.5)'} onBlur={e => e.target.style.borderColor = 'rgba(14,165,233,0.15)'} data-id="element-19" />
                    </div>

                    <div data-id="element-20">
                      <label className="block text-xs font-bold mb-2 uppercase tracking-wider" style={{
                  color: '#475569'
                }} data-id="element-21">
                        <Mail size={11} className="inline mr-1" data-id="element-22" />
                        Correo electrónico
                      </label>
                      <input type="email" required value={form.email} onChange={e => setForm({
                  ...form,
                  email: e.target.value
                })} placeholder="tu@correo.com" className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-all" style={{
                  backgroundColor: 'rgba(14,165,233,0.05)',
                  border: '1px solid rgba(14,165,233,0.15)',
                  color: '#F1F5F9'
                }} onFocus={e => e.target.style.borderColor = 'rgba(14,165,233,0.5)'} onBlur={e => e.target.style.borderColor = 'rgba(14,165,233,0.15)'} data-id="element-23" />
                    </div>

                    <div data-id="element-24">
                      <label className="block text-xs font-bold mb-2 uppercase tracking-wider" style={{
                  color: '#475569'
                }} data-id="element-25">
                        <MessageSquare size={11} className="inline mr-1" data-id="element-26" />
                        Mensaje
                      </label>
                      <textarea required rows={4} value={form.message} onChange={e => setForm({
                  ...form,
                  message: e.target.value
                })} placeholder="¿En qué podemos ayudarte?" className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-all resize-none" style={{
                  backgroundColor: 'rgba(14,165,233,0.05)',
                  border: '1px solid rgba(14,165,233,0.15)',
                  color: '#F1F5F9'
                }} onFocus={e => e.target.style.borderColor = 'rgba(14,165,233,0.5)'} onBlur={e => e.target.style.borderColor = 'rgba(14,165,233,0.15)'} data-id="element-27" />
                    </div>

                    <motion.button type="submit" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="w-full py-4 rounded-xl text-sm font-black uppercase tracking-wide flex items-center justify-center gap-2" style={{
                backgroundColor: '#0EA5E9',
                color: '#050A14'
              }} data-id="element-28">
                      <Send size={15} data-id="element-29" />
                      Enviar Mensaje
                    </motion.button>

                    <p className="text-center text-xs" style={{
                color: '#334155'
              }} data-id="element-30">
                      También puedes escribirnos directamente a{' '}
                      <span style={{
                  color: '#38BDF8'
                }} data-id="element-31">
                        soporte@arquitectosdelfuturo.com
                      </span>
                    </p>
                  </motion.form>}
              </AnimatePresence>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}